import React from 'react';
import PropTypes from 'prop-types';
import { EyeOutlined } from '@ant-design/icons';
// eslint-disable-next-line import/no-extraneous-dependencies
import dayjs from 'dayjs';
import { FormContainer, SectionTitle, StyledTable, ViewButton } from '../CreateDriverPageV2.styles';

export default function DriverDetailsTable({ driversList, onViewDriver }) {
	// Table columns
	const columns = [
		{
			title: 'Vendor',
			dataIndex: 'vendor_name',
			key: 'vendor_name',
		},
		{
			title: 'Driver Name',
			dataIndex: 'driver_name',
			key: 'driver_name',
		},
		{
			title: 'Vehicle Type',
			dataIndex: 'vehicle_type_name',
			key: 'vehicle_type_name',
		},
		{
			title: 'Mobile Number',
			dataIndex: 'mobile_number',
			key: 'mobile_number',
		},
		{
			title: 'Driving License',
			dataIndex: 'driving_license_valid_till',
			key: 'driving_license',
			render: (date) => (date ? dayjs(date).format('DD-MM-YYYY') : '-'),
		},
		{
			title: 'Actions',
			key: 'actions',
			render: (_, record) => (
				<ViewButton onClick={() => onViewDriver(record)}>
					<EyeOutlined style={{ fontSize: 18, color: '#1890ff' }} />
				</ViewButton>
			),
		},
	];

	return (
		<FormContainer>
			<SectionTitle>Driver Details</SectionTitle>
			<StyledTable
				columns={columns}
				dataSource={driversList}
				rowKey="id"
				pagination={false}
				bordered
			/>
		</FormContainer>
	);
}

DriverDetailsTable.propTypes = {
	driversList: PropTypes.array.isRequired,
	onViewDriver: PropTypes.func.isRequired,
};
